import { Controller, useFormContext } from 'react-hook-form';
import { Box } from 'enova-frontend-components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AboutFormControlProps } from '../../types';
import { CheckboxArea } from '../components/checkboxArea';

import { Gasskamin } from './gasskamin';
import { Gasskjel } from './gasskjel';

const emptyValue = {
  kamin: {
    selected: false,
    value: undefined
  },
  kjel: {
    selected: false,
    value: undefined
  }
};

export const Gass: FC<AboutFormControlProps> = ({ control }) => {
  const { setValue } = useFormContext();
  const { t } = useTranslation();

  return (
    <Controller
      control={control}
      name="oppvarmingSelection.oppvarmingGass"
      rules={{
        validate: (value, formValues) => {
          const oppvarmingGass = formValues.oppvarming?.oppvarmingGass;

          // If "Gass" is selected, at least one of Kjel or Kamin must be selected
          if (value && !oppvarmingGass?.kjel?.selected && !oppvarmingGass?.kamin?.selected) {
            return t('register.errorMessage.field.oppvarmingGass');
          }

          return true;
        }
      }}
      render={({ field: { value, onChange }, fieldState }) => (
        <CheckboxArea
          i18nPrefix="register.tekniskUtstyr.oppvarmingGass"
          value={!!value}
          error={fieldState.error}
          onChange={(checked: boolean) => {
            onChange(checked);
            if (!checked) {
              setValue(`oppvarming.oppvarmingGass`, emptyValue);
            }
          }}
        >
          <Box gap={3} display="flex" flexDirection="column">
            <Gasskamin control={control} />
            <Gasskjel control={control} />
          </Box>
        </CheckboxArea>
      )}
    />
  );
};
